// This is the recommended regular expression from the Lexical Playground Link Plugin.
const URL_REG_EXP = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/);
export const DEFAULT_VALIDATE_URL = (url) => {
    return url === 'https://' || URL_REG_EXP.test(url);
};
export const DEFAULT_ATTRIBUTES = {
    rel: 'noopener noreferrer',
    target: '_blank',
};
//# sourceMappingURL=defaults.js.map